import type { Dispatch } from 'redux'
import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'

type ActionFeaturesResponse = {
    type: 'FEATURES_RECEIVED',
    features: Array<string>
}

const actionFeaturesReceived = (
    features: Array<string>
): ActionFeaturesResponse => ({
    type: 'FEATURES_RECEIVED',
    features
})

const fetchAvailableFeatures = () => {
    return (dispatch: Dispatch<any>) => {
        return ws
            .get(endpoints.features)
            .then(response => dispatch(actionFeaturesReceived(response.data)))
            .catch(error =>
                console.error('Error fetching available features', error)
            )
    }
}

export { fetchAvailableFeatures }

export type Action = ActionFeaturesResponse
